// Event Utils functions

export const getDefaultImage = (event) => {
    const categoryImage = `/images/events/${event.category.toLowerCase()}.jpg`;
    return event.image || categoryImage || "/images/events/default.jpg";
};

export const formatDate = (date) => {
    const options = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
    };
    return new Date(date).toLocaleDateString('fr-FR', options);
};

export const getLocation = (event) => {
    return event.location || "Location not specified";
};

const eventUtils = {
    getDefaultImage,
    formatDate,
    getLocation
};

export default eventUtils;
